import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SearchService } from 'src/app/Services/search.service';
import { CookieService } from 'ngx-cookie-service';
declare var $: any;
@Component({
  selector: 'app-pid-approval',
  templateUrl: './pid-approval.component.html',
  styleUrls: ['./pid-approval.component.css']
})
export class PIDApprovalComponent implements OnInit {
  subscription: Subscription;
  searchPIDAdapter: any;
  PIDSearchColumns: any[];
  searchPIDSource: any;
  constructor(private httpRequestService: HttpRequestService,
    private searchService: SearchService,
    private router: Router,
    private property: PropertiesService,
    private Cookie: CookieService) {
    this.subscription = searchService.searchRefreshEvt$.subscribe(() => {
      this.getGridData();
    });
  }
  ngOnInit() {
    this.gridInint();
    this.getGridData();
    console.log('UserName: ' + this.Cookie.get('projectUserName'));
    console.log('UserPassword: ' + this.Cookie.get('projectUserPassword'));
  }
  ngAfterViewInit(): void {
    this.gridInint();
    this.getGridData();
  }
  gridInint() {
    var compScope = this;
    this.PIDSearchColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        { text: 'Project Name', datafield: 'ProjectName', width: '30%' },
        { text: 'Project Code', datafield: 'ProjectCode', width: '20%' },
        { text: 'Project Type', datafield: 'ItemDescrip', width: '20%' },
        { text: 'Client Name', datafield: 'ClientName', width: '15%' },
        {
          text: 'Request for Approval', width: '15%', datafield: 'Request Approval', columntype: 'custom',
          createeditor: (row: number, value: any, editor: any): void => {
            var textBox = $("<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>").appendTo(editor);
            $(textBox).click(function () {
              setTimeout(function () {
                $('#searchPID').jqxGrid('selectrow', row);
                compScope.SendForApproval(row);
              }, 0);
            })
          },
          cellsrenderer: function (row) {
            return "<button class='jqx-rc-all jqx-button jqx-widget jqx-element-container jqx-fill-state-normal jqx-primary' id='linkButton'> Approve </button>";
          },
          buttonclick: function (row) {
            $('#searchPID').jqxGrid('selectrow', row);
            compScope.SendForApproval(row);
          },
        },
      ];
    this.searchPIDSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'TransID', type: 'int' },
        { name: 'ProjectName', type: 'string' },
        { name: 'ProjectCode', type: 'string' },
        { name: 'ItemDescrip', type: 'string' },
        { name: 'ClientName', type: 'string' },
      ],
      id: 'transid',
      localdata: ''
    };
  }
  SendForApproval(row) {

  }
  RowclickPIDSearch(event: any): void {
    var args = event.args;
    var selectedRowIndex = args.rowindex;
    // this.searchItem.emit();
    args.row.bounddata.timestamp = new Date().getTime();
    console.log(args);
    this.router.navigate(['home/PID'], { queryParams: args.row.bounddata });

  }
  getGridData() {
    this.getData().then((list: any) => {
      this.searchPIDSource.localdata = list.result;
      console.log(list.result);
      this.searchPIDAdapter = new jqx.dataAdapter(this.searchPIDSource);
      $(".searchPID").jqxGrid('updatebounddata');
    });

  }
  getData() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + "/pid/all?branchCode=1")
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }

}
